import {Box, Typography} from "@mui/material";
import {styled} from "@mui/system";

export const HeaderNotificationBox = styled(Box)({
    display: 'flex',
    padding: '6px 8px 6px 12px',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: 'var(--cherry)'
})

export const HeaderText = styled(Typography)({
    color: 'var(--grey-grey-01)',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px'
})
